import React, { useState, useEffect, useRef } from 'react';
import { Link, useParams, useNavigate } from "react-router-dom"
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import branchManagerRescheduleStyles from "../../../styles/branchManager/reschedule.module.css";
import { useDispatch, useSelector } from "react-redux";
import {useForm} from 'react-hook-form'
import * as yup from 'yup'
import {yupResolver} from "@hookform/resolvers/yup";
import branchAppointmentDataClient from '../../../utility/features/api_clients/appointment/getBranchAppointmentData'
import saveAppointmentsClient from '../../../utility/features/api_clients/appointment/saveAppointmentsClient'
import {encryptData} from '../../../utility/helpers/hashing';
import Loader from '../../loader/index';
import {setAppointmentData} from '../../../reduxStore/appointment/appointmentSlice'
import TyChck from '../../../assets/appointment_schedule/ty-check.svg';
import Layout from './layout';

const Reschedule = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { postCode, recordId } = useParams();
    const { data: appointmentList } = useSelector((state) => state.appointment);
    //const selectedAppointment = appointmentList.find(itm => itm.postalcode == id);
    //const postalCode = selectedAppointment?selectedAppointment.postalcode:id;
    const [errorMessage, setErrorMessage] = useState("");
    const [saveAppointmentStatus, setSaveAppointmentStatus] = useState("");
    const [branchId, setBranchId] = useState(null);
    const [appointmentDetails, setAppointmentDetails] = useState(null);

    const [form, setForm] = useState({
        appointmentDate : {},
        appointmentTime : {}
    });

    const appointmentFormRef = useRef(null);
    const appointmentFormBtnRef = useRef(null);

    const fetchBranchAppointmentData = async () => {
        setErrorMessage("");

        try {
            const result = await branchAppointmentDataClient(postCode);

            const { status, data } = result ?? {};

            let appointmentInfo = data.availableTimeBlocks || [];

            if(data.isBranchEnabled == true && data.isZipActive == true){
                if(isDateSlotAvailable(appointmentInfo) == 0){
                    console.log("ERROR :  date and time slot is not available.");
                    setSaveAppointmentStatus("no_schedule");
                } else {
                    /* save appointment */
                    setBranchId(data.branchId);
                    setAppointmentDetails(appointmentInfo);
                }
                //hideLoader();
            } else {
                //hideLoader();
                setBranchId(data.branchId);
                setAppointmentDetails(appointmentInfo);
                console.log(`ERROR : branch is ${data.isBranchEnabled == true?"enabled":"not enabled"} and zipcode is ${data.isZipActive == true?"active":"inactive"}.`);
                setSaveAppointmentStatus("error");
            }
        }
        catch (err) {
            console.error("Error calling branch appointment details api : ", err);
            setSaveAppointmentStatus("error");
        } finally {
        }
    }

    useEffect(() => {

        (async () => {
            await fetchBranchAppointmentData();
        })();

    }, []);

    useEffect(() => {
        if(appointmentDetails){
            /* disabled continue button */
            if(appointmentFormBtnRef.current != null) appointmentFormBtnRef.current.disabled=true;
        }
    }, [appointmentDetails]);

    useEffect(() => {
        if(Object.keys(form.appointmentDate).length > 0){
            /* on each date selection by default all time will be unselected */
            Object.values(document.querySelectorAll(`#${appointmentFormRef.current.id} input[type=checkbox]`)).map((itm) => itm.checked = false);

            /* disabled continue button */
            appointmentFormBtnRef.current.disabled=true;
        }
    }, [form.appointmentDate]);

    const formSchemaAppointment = yup.object().shape({
        appointmentDate: yup.string().required("Required").label("Appointment Date"),
        appointmentTime: yup.string().required("Required").label("Appointment Time")
    });

    const {register: registerAppointment, handleSubmit: handleSubmitAppointment, setError: setErrorAppointment, getValues:getValuesAppointment, clearErrors:clearErrorsAppointment, formState: {errors: errorsAppointment}, setValue: setValueAppointment} = useForm({
        mode: "onChange",
        defaultValues: {
            appointmentDate: {},
            appointmentTime: {}
        },
        resolver: yupResolver(formSchemaAppointment)
    });

    const handleForm = (e = null, type, value = null) => {
        /* trim value */
        let val = value === null ? e.target.value : value;

        /* created new form object with manipulated data */
        let formObj = {
        ...form,
        [type]: val
        };
        
        /* save */
        setForm(formObj);
    }

    const scheduleTime = (time = "") => {
        const timeString = time;

        // Create a Date object. We can use an arbitrary date, as we only care about the time.
        // It's important to include a date to create a valid Date object.
        const dummyDate = new Date(`2000-01-01T${timeString}`);

        // Use toLocaleTimeString to format the time into a locale-sensitive string with AM/PM.
        // 'en-US' is used for US English formatting, which includes AM/PM.
        // The options object specifies to display only the hour and minute in 12-hour format with AM/PM.
        const formattedTime = dummyDate.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true // Ensures 12-hour format with AM/PM
        });
        return formattedTime;
    }

    const scheduleDateFormat = (dateStr = "") => {
        if (!dateStr) return "";
        let dateObj;
        // If format is YYYY-MM-DD, parse as local date
        if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
            const [year, month, day] = dateStr.split('-').map(Number);
            dateObj = new Date(year, month - 1, day);
        } else {
            dateObj = new Date(dateStr);
        }
        
        if (isNaN(dateObj.getTime())) return "";

        const monthName = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const month = monthName[dateObj.getMonth()];
        const day = dateObj.getDate();

        return `${month} ${day}`;
    }

    const scheduleTimeFormat = (time = "") => {
        const timeString = time;

        // Create a Date object. We can use an arbitrary date, as we only care about the time.
        // It's important to include a date to create a valid Date object.
        const dummyDate = new Date(`2000-01-01T${timeString}`);

        // Use toLocaleTimeString to format the time into a locale-sensitive string with AM/PM.
        // 'en-US' is used for US English formatting, which includes AM/PM.
        // The options object specifies to display only the hour and minute in 12-hour format with AM/PM.
        const formattedTime = dummyDate.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true // Ensures 12-hour format with AM/PM
        });
        return formattedTime;
    }

    const onSubmitAppointment = async (data) => {
        setErrorMessage("");

        /* call step 2 user info */
        try {
            //showLoader();
            appointmentFormBtnRef.current.disabled = true;
            appointmentFormBtnRef.current.innerText = "Processing ...";
            const resUserInfo = await saveAppointmentsClient({
                "BranchId": branchId,
                "ApptDate": form.appointmentDate.date,
                "StartTime": form.appointmentTime.startTime.toLowerCase(),
                "EndTime": form.appointmentTime.endTime.toLowerCase(),
                "RecordId": recordId + `__apptvalue${Date.now()}`,
                "AppointmentType": "reschedule"
            });
            //hideLoader();
            appointmentFormBtnRef.current.disabled = false;
            appointmentFormBtnRef.current.innerText = "Submit";

            /* if slot successfully booked */
            if (resUserInfo.data && resUserInfo.data.appointmentId && resUserInfo.data.appointmentId >= 0) {
                /* set form state as submitted and display thankyou */
                //handleForm(null, 'stepComplete', 2);
                setSaveAppointmentStatus("success");
                dispatch(setAppointmentData([]));
                //alert('Updated !');
                //navigate('/branch-manager');
            } else {
                setErrorAppointment("appointmentTime", { type: "manual", message: resUserInfo.data.message });
                return false;
            }
        } catch (err) {
            console.log("ERROR : ", err);
            //setErrorMessage(err || "Unexpected response from server.");
            setSaveAppointmentStatus("error");
            // kickOutCall("ERROR : saveAppointmentsClient api error occured.", JSON.stringify({
            //     "form": form,
            //     "BranchId": form.branch,
            //     "ApptDate": form.appointmentDate.date,
            //     "StartTime": form.appointmentTime.startTime.toLowerCase(),
            //     "EndTime": form.appointmentTime.endTime.toLowerCase(),
            //     "RecordId": userRecordID
            // }), JSON.stringify(err));
            //hideLoader();
        }
    }

    const handleDateSelection = (dateInfo) => {
        let formObj = {
            ...form,
            "appointmentDate": { "date": dateInfo.appointmentDate, "weekDay": dateInfo.weekDay },
            "appointmentTime": {}
        };
        setForm(formObj);
        setValueAppointment('appointmentDate', JSON.stringify({ "date": dateInfo.appointmentDate, "weekDay": dateInfo.weekDay }));
        clearErrorsAppointment('appointmentDate');
        setValueAppointment('appointmentTime', JSON.stringify({}));
        clearErrorsAppointment('appointmentTime');
    }

    const handleTimeSelection = (timeInfo) => {
        handleForm(null, 'appointmentTime', timeInfo);
        setValueAppointment('appointmentTime', JSON.stringify(timeInfo));
        clearErrorsAppointment('appointmentTime');
        appointmentFormBtnRef.current.disabled = false;
    }

    const isDateSlotAvailable = (appointmentInfo, countOnly = true) => {
        let availableDateSlots = [];
        let availableDateSlotCount = 0;

        availableDateSlots = appointmentInfo.filter((dateInfo) => isTimeSlotAvailable(appointmentInfo, dateInfo.appointmentDate) > 0);

        availableDateSlotCount = availableDateSlots.length;
        return countOnly ? parseInt(availableDateSlotCount) : availableDateSlots;
    }

    const isTimeSlotAvailable = (appointmentInfo, date, countOnly = true) => {

        let dateSlot = appointmentInfo.filter((itm, i) => itm.appointmentDate == date);

        let availableTimeSlots = [];
        let availableTimeSlotCount = 0;

        if (dateSlot.length > 0) {
            availableTimeSlots = dateSlot[0].availableTimeBlocks.filter((timeInfo) => parseInt(timeInfo.availableAppointments) > 0 && String(timeInfo.isAvailable).toLowerCase().toString() == "true");

            availableTimeSlotCount = availableTimeSlots.length;
        }

        return countOnly ? parseInt(availableTimeSlotCount) : availableTimeSlots;
    }

    return (<>
        <Layout> 
            <div className="d-flex align-items-center justify-content-between mb-4">
                <div className="d-flex align-items-center gap-3">
                    <Link  className={`btn btn-outline-success btn-sm`} to={`/configure/branch-manager`}>{`← Back`}</Link>
                    <div>
                        <h2 className="m-0">Reschedule</h2>
                        {/* <small className="text-muted">Branch Manager Dashboard</small> */}
                    </div>
                    {errorMessage != "" && <p className={`${branchManagerRescheduleStyles['invalid-feedback']} d-block`}>{errorMessage}</p>}
                </div>
            </div>

            {appointmentDetails != null ? 
            <>
                <div className={`container ${branchManagerRescheduleStyles['appointment-schedule-container']}`}>
                    {saveAppointmentStatus == "" && <div className={`row py-2 ${branchManagerRescheduleStyles['appointment-tab']}`}>
                        <div class="row">
                            <div class="col-6">
                                <div class="top-head">Let’s set a date</div>
                            </div>
                            <div class="col-6 text-end">
                                <div class="info-text">* Required information</div>
                            </div>
                        </div>
                        <form ref={appointmentFormRef} className={`${branchManagerRescheduleStyles['appointment-form']} needs-validation d-flex flex-column`} onSubmit={handleSubmitAppointment(onSubmitAppointment)} noValidate id="appointmentForm" name="appointmentForm">
                            <div className={`row ${branchManagerRescheduleStyles['select-date']}`}>
                                <div className="col-12">
                                    <div className={`${branchManagerRescheduleStyles['sec-heading']}`}>{`Select your preferred date*`}</div>
                                </div>
                                {isDateSlotAvailable(appointmentDetails, false).map((dateInfo, i) => <div className="col-6 mt-2" key={`dateOption_${i}`} >
                                    <label className="date" tabIndex="0">
                                        <input type="radio" name="appointmentDate" {...registerAppointment("appointmentDate")} className={`${branchManagerRescheduleStyles['radio-input-element']}`} value={dateInfo.appointmentDate} checked={form.appointmentDate.date == dateInfo.appointmentDate ? true : false} onChange={(e) => handleDateSelection(dateInfo)} />
                                        <div className={`${branchManagerRescheduleStyles['radio-input']} ${branchManagerRescheduleStyles['date-time-input']}`}>
                                            <p className={`${branchManagerRescheduleStyles['date-time']}`}>{`${dateInfo.weekDay.substr(0, 3)}, ${scheduleDateFormat(dateInfo.appointmentDate)}`}</p>
                                        </div>
                                    </label>
                                </div>)}
                                <div className="col-12 mt-2">

                                    {errorsAppointment.appointmentDate && <p className={`${branchManagerRescheduleStyles['invalid-feedback']} d-block`}>{errorsAppointment.appointmentDate?.message}</p>}
                                </div>

                            </div>
                            {isTimeSlotAvailable(appointmentDetails, form.appointmentDate.date) > 0 && <div className={`row ${branchManagerRescheduleStyles['select-time']}`}>
                                <div className="col-12">
                                    <div className={`${branchManagerRescheduleStyles['sec-heading']}`}>{`Select your preferred time (choose all that apply)*`}</div>
                                </div>
                                {isTimeSlotAvailable(appointmentDetails, form.appointmentDate.date, false).map((timeInfo, j) => {

                                    return <div className="col-12 mt-2" key={`timeOption_${j}`}>
                                        <label className={`${branchManagerRescheduleStyles['time']}`} tabIndex="0">
                                            <input type="checkbox" name="appointmentTime" {...registerAppointment("appointmentTime")} id={`time_${j}`} disabled={timeInfo.availableAppointments < 1 || timeInfo.isAvailable == false ? true : false} className={`${branchManagerRescheduleStyles['radio-input-element']}`} value={`${scheduleTime(timeInfo.startTime)} – ${scheduleTime(timeInfo.endTime)}`} checked={Object.keys(form.appointmentTime).length > 0 && form.appointmentTime.startTime == timeInfo.startTime && form.appointmentTime.endTime == timeInfo.endTime ? true : false} onChange={(e) => handleTimeSelection(timeInfo)} />
                                            <div className={`${branchManagerRescheduleStyles['radio-input']} ${branchManagerRescheduleStyles['date-time-input']}`}>
                                                <p className={`${branchManagerRescheduleStyles['date-time']}`}>{timeInfo.sessionLabel} {scheduleTime(timeInfo.startTime).toLowerCase()} – {scheduleTime(timeInfo.endTime).toLowerCase()}</p>
                                            </div>
                                        </label>

                                    </div>;
                                })}
                                <div className="col-12 mt-2">

                                    {errorsAppointment.appointmentTime && <p className={`${branchManagerRescheduleStyles['invalid-feedback']} d-block`}>{errorsAppointment.appointmentTime?.message}</p>}
                                </div>

                            </div>}
                            <button id="next-btn" type="submit" ref={appointmentFormBtnRef} className={`btn ${branchManagerRescheduleStyles['continue-btn']}`} >{`Submit`}</button>
                            <div className="row">
                                <div className="col-12">

                                </div>
                            </div>
                        </form>
                    </div>}
                    {saveAppointmentStatus != "" && <div id="thank-you-section" className="">
                        <div class="d-flex gap-2">
                            <div class="mb-3 d-block">{saveAppointmentStatus == "success" && <img src={TyChck} width="65px" height="73px"/>}</div>
                            <h2 class="appointment-title pt-3">{`Thank you!`}</h2>
                        </div>
                        
                        {saveAppointmentStatus == "success" && <>
                            <p className="appointment-subtitle">{`You have requested a consultation on `}<span>{form.appointmentDate.weekDay}{`, `}{scheduleDateFormat(form.appointmentDate.date)}</span>{` between the hours 
                            of `}<span>{scheduleTime(form.appointmentTime.startTime).toLowerCase()}</span>{` - `}<span>{scheduleTime(form.appointmentTime.endTime).toLowerCase()}</span>.</p>
                            <p className="appointment-subtitle" >{`We will follow up via email once this date and time are confirmed. If your requested date and time are unavailable, we will reach out to reschedule.`}</p>
                        </>}

                        

                        {saveAppointmentStatus == "error" && <p className='appointment-subtitle'>{`Unfortunately consultation scheduling isn’t currently available in your area, but our representatives are here to help.`}</p>}

                        {saveAppointmentStatus == "no_schedule" && <p className="appointment-subtitle" >{`Unfortunately at this time there is no availability. Please try again at a later date.`}</p>}
                        
                        
                    </div>}
                </div>
                {/* <pre>
                    {JSON.stringify(appointmentDetails)}
                </pre> */}
            </> : <Loader />}
        </Layout>
    </>);

}

export default Reschedule;